import React, { useState, useEffect } from 'react';
import styles from './Sidebar.module.css';

const Sidebar = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // 5 se 15 seconds ke darmiyan random timer
    const randomTime = Math.floor(Math.random() * (15000 - 5000 + 1) + 5000);

    const timer = setTimeout(() => {
      setIsVisible(true);
      
      // 5 seconds show hone ke baad khud band ho jaye
      setTimeout(() => setIsVisible(false), 5000);
    }, randomTime);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className={styles.sidePosterContainer}>
      <div className={styles.posterContent}>
        <button className={styles.closeBtn} onClick={() => setIsVisible(false)}>×</button>
        {/* Aapki image Sidebar.png honi chahiye */}
        <img src="/Sidebar.png" alt="Promotion" />
      </div>
    </div>
  );
};

export default Sidebar;